import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@dotcom/crown-ui';
import { AbandonButtonProps, CancelButtonProps, SubmitButtonProps } from '../save-project-dialog-types';
import styles from '../save-project-dialog.module.scss';

export const CancelButton = ({ onCancel }: CancelButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button onClick={onCancel} variant="secondary" className={styles['footer-button']}>
      {t('saveProjectDialog.cancelButton')}
    </Button>
  );
};

export const SubmitButton = ({ onSaveProject, isLoggedIn, onSignIn }: SubmitButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="primary"
      onClick={isLoggedIn ? onSaveProject : onSignIn}
      type="submit"
      className={styles['footer-button']}
    >
      {isLoggedIn ? t('saveProjectDialog.saveProjectButton') : t('saveProjectDialog.signInButton')}
    </Button>
  );
};

export const AbandonProjectButton = ({ onAbandon }: AbandonButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button onClick={onAbandon} variant="secondary" className={styles['footer-button']}>
      {t('saveProjectDialog.abandonButton')}
    </Button>
  );
};
